import { TransactionTotalsEntity } from "@modules/finances/entities/transactionTotalsEntity"
import { type FinanceStatisticsDto } from "@modules/finances/gateway/financeStatisticsDto"
import { PayoutTransferStatus } from "@modules/finances/types/financesType"

export class FinanceStatisticsEntity {
  counts: TransactionTotalsEntity
  stats: {
    netTotal: number
    outOfBandTotal: number
    feesTotal: number
    refundTotal: number
    sepaDebitAmountTotal: number
    currency: string
    activeCustomers: number
    currentBalance: {
      pending: number
      available: number
    }
    lastPayout: {
      amount: number
      arrivalDate: string | null
      status: PayoutTransferStatus
    } | null
    payoutTotalAmount: number
  }
  firstPeriod: string | null
  isMissingDocumentsError: boolean
  toValidate: {
    failed: {
      count: number
      total: number
    }
    pending: {
      count: number
      total: number
    }
    disputed: {
      count: number
      total: number
    }
    totalCount: number
    totalAmount: number
  }

  private constructor(data: FinanceStatisticsEntity) {
    this.counts = data.counts
    this.stats = data.stats
    this.firstPeriod = data.firstPeriod
    this.isMissingDocumentsError = data.isMissingDocumentsError
    this.toValidate = data.toValidate
  }

  static fromDto(dto: FinanceStatisticsDto) {
    return new FinanceStatisticsEntity({
      counts: TransactionTotalsEntity.fromDto(dto.counts),
      stats: dto.stats,
      firstPeriod: dto.firstPeriod,
      isMissingDocumentsError: dto.isMissingDocumentsError,
      toValidate: {
        ...dto.toValidate,
        totalCount: dto.toValidate.failed.count + dto.toValidate.pending.count + dto.toValidate.disputed.count,
        totalAmount: dto.toValidate.failed.total + dto.toValidate.pending.total + dto.toValidate.disputed.total,
      },
    })
  }
}
